import Page from '../../../layout/Page/Page';
import PageWrapper from '../../../layout/PageWrapper/PageWrapper';
import CommonTrainingEmployeeList from './Common/CommonTrainingEmployeeList';

const TrainingEmployeePage = () => {
    return (
        <PageWrapper title="Treinamentos do Colaborador">
            <Page container="fluid">
                <div className="row h-100">
                    <div className="col-12">
                        <CommonTrainingEmployeeList />
                    </div>
                </div>
            </Page>
        </PageWrapper>
    );
};

export default TrainingEmployeePage;
